import { LogLevel, NAMESPACE, Role, ServerLog } from '@sodamnfoolish/spl-factory-backend-automatization';
import { Manager } from 'socket.io-client';

export const createAutomatizationGatewayClient = (url: string, apiKey: string, room: string, role: Role) =>
    new Manager(url, {
        extraHeaders: {
            'x-api-key': apiKey,
        },
        query: {
            room,
            role,
        },
        // autoConnect: false,
        // reconnection: false,
    })
        .socket(NAMESPACE)
        .onAnyOutgoing((event: string) => console.debug(`Automatization gateway outgoing`, event));

export const logServerLog = (
    serverLog: ServerLog,
    logMessage: ((message: string, type: 'success' | 'warn' | 'error' | undefined) => void) | undefined = undefined,
) => {
    const message = (serverLog.role ? `[${serverLog.role}]` : '') + (serverLog.clientId ? `[${serverLog.clientId}]` : '') + serverLog.message;

    if (logMessage) logMessage(message, serverLog.level == LogLevel.Warn ? 'warn' : serverLog.level == LogLevel.Error ? 'error' : undefined);
    (serverLog.level == LogLevel.Warn ? console.warn : serverLog.level == LogLevel.Error ? console.error : console.log)(message);
};
